const isIOS = (ua) => /iPad|iPhone|iPod/.test(ua);

const robotaxi = {
  async closeWebView() {
    if (isIOS(navigator.userAgent)) {
      window.webkit.messageHandlers.closeWebView.postMessage('');
    } else {
      window.saicpassenger.closeWebView();
    }
  },
};

export default robotaxi;
